/*
  Validation rules for forms. Usage example:

  <template>
    <q-input
      v-model="email"
      label="Email"
      :rules="[ruleRequired, ruleEmail]"
    />
  </template>

  <script>
    import { ruleEmail, ruleRequired } from '@/utils/validation'
    methods: {
      ruleEmail,
      ruleRequired,
      ...
    }
  </script>
*/

const emailPattern =
  /^(?=.{6,254}$)(?=.{1,64}@)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.){1,10}[a-zA-Z]{2,63}$/
// const phonePattern = /^(\+61\d{9}|04\d{8}|9\d{7})$/

const phonePattern = /^\d{10,}$/
const locidPattern = /^LOC\d{12}$/

export const ruleEmail = val => emailPattern.test(val) || 'Invalid email'
export const rulePhone = val => phonePattern.test(val) || 'Invalid phone number'
export const ruleLocId = val => locidPattern.test(val) || 'Invalid LOCID'

export const ruleRequired = val =>
  (Array.isArray(val) && val.length) ||
  (!Array.isArray(val) && !!val) ||
  'Answer required'

export const rulePhoneNotRequired = val =>
  !val || phonePattern.test(val) || 'Invalid phone number'

export const rule6CharactersOnly = val => val.length === 6 || false
export const ruleNumbers = val => /^[0-9]+$/.test(val) || false
export const rule15CharactersOnly = val =>
  val.length === 15 || 'Please input 15 characters only'
export const ruleAVCFormat = val =>
  /^AVC\d{12}$/.test(val) || 'Please input a valid AVCID'
